import { zodResolver } from "@hookform/resolvers/zod";
import { Form, FormControl, FormField, FormItem, FormMessage } from "components/ui/form";
import { Textarea } from "components/ui/textarea";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AppLog } from "services";
import { z } from "zod";
import { RequestApi, RouteApi, RouteUrl, StatusMsg } from "utils";

export default function SendRequestFeedback() {
  const navigate = useNavigate();

  const FormSchema = z.object({
    remark: z.string().min(1, {
      message: "Input is required*",
    }),
  });
  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      remark: "",
    },
  });

  const onSubmit = async (data: z.infer<typeof FormSchema>) => {
    try {
      let url: string = "";
      url = RouteApi.submitRequestFeedback;

      const dataApi = {
        remark: data.remark,
      };

      const response = await RequestApi(url, { data: dataApi });
      if (response.status === "success") {
        navigate(
          `${RouteUrl.receiveRequestFeedback}?title=Share Your Thoughts – Help Us Improve!&description=Thank you for helping us make FlipFlop even better! Together, we can create a platform that works for everyone.`
        );
      } else {
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[onSubmit]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex justify-center items-center min-h-screen bg-gray-50">
          <div className="flex justify-center p-6 bg-white rounded-lg shadow-lg">
            <div className="max-w-lg w-full space-y-8 text-center">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-sans text-gray-700 font-light">Support Center</h1>
              <h2 className="font-semibold text-xl md:text-3xl lg:text-4xl text-blue-600">Share Your Thoughts – Help Us Improve!</h2>
              <p className="text-gray-600">
                Your feedback matters to us! We're constantly working to make FlipFlop better for you, and your insights play a crucial role in helping us understand what works
                well and what needs improvement.
              </p>

              <FormField
                control={form.control}
                name="remark"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <Textarea
                        placeholder="Please input your feedback here..."
                        {...field}
                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </FormControl>
                    <FormMessage className="text-red-500 mt-2 text-sm" />
                  </FormItem>
                )}
              />

              <button type="submit" className="bg-blue-500 text-white px-6 py-2 rounded-md font-medium w-full hover:bg-blue-600 transition duration-200">
                Send
              </button>
            </div>
          </div>
        </div>
      </form>
    </Form>
  );
}
